export default __webpack_public_path__ + "static/media/user.269aeae6.png";